module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-by.15aaf67a.png";